import { useTheme } from "@emotion/react"
import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import Page from "./Page"

import testa_pepper from 'assets/images/testa_pepper.png'

const MessagePage = ({ message }) => {
    const theme = useTheme()

    return (
        <Page bg={theme.palette.background.paper}>
            <Box sx={{
                minHeight: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }} >
                <img src={testa_pepper} alt="testa pepper" />
                <Typography variant="h5" color={theme.palette.text.primary} sx={{
                    paddingInline: '2rem',
                    textAlign: 'center'
                }}>
                    {message}
                </Typography>
            </Box>
        </Page>
    )
}

export default MessagePage